'use strict';

module.exports = {
    ELECTRON_MASS: 5.48579909070e-4
};



// WEBPACK FOOTER //
// ./node_modules/chemical-elements/src/constants.js